import { SxProps, Theme } from '@mui/material';

export const modalStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 3,
      maxHeight: '90vh',
      overflow: 'hidden',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeButton: {
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.04)',
    },
  },
  tabs: {
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 500,
      minHeight: 48,
    },
    '& .Mui-selected': {
      color: '#1976d2',
    },
  },
  uploadBox: {
    border: '2px dashed #ccc',
    borderRadius: 2,
    p: 4,
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#1976d2',
      backgroundColor: '#f5f5f5',
    },
  },
  validateButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
  newSourceButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
    '& .MuiTableCell-head': {
      fontWeight: 'bold',
    },
  },
  workspaceChip: {
    cursor: 'pointer',
  },
} as const;

export type ModalStyles = typeof modalStyles; 